import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { ISupportCaseInfo, ISupportCaseInfoQuery } from '../../models';
import { queryKeys } from '../../../shared';

async function getSupportCaseInfo(query: ISupportCaseInfoQuery): Promise<ISupportCaseInfo[]> {
    const { data } = await axios(`/support-api/support-cases/info`, { params: query });
    return data;
}

export const useSupportCaseInfo = (query: ISupportCaseInfoQuery) => {
    const { id, cardCode, nationalSecurityNumber, organisationId } = query;
    return useQuery<ISupportCaseInfo[], AxiosError>({
        queryKey: [queryKeys.SUPPORT_CASE_INFO, query],
        queryFn: () => getSupportCaseInfo(query),
        enabled:
            (!!id && !!organisationId) ||
            (!!cardCode && !!organisationId) ||
            (!!nationalSecurityNumber && !!organisationId),
        retry: false,
    });
};
